import { render } from "./AdminpanelLayout.vue?vue&type=template&id=ed0093d6&scoped=true"
import script from "./AdminpanelLayout.vue?vue&type=script&lang=js"
export * from "./AdminpanelLayout.vue?vue&type=script&lang=js"

import "./AdminpanelLayout.vue?vue&type=style&index=0&id=ed0093d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed0093d6"]])

export default __exports__